import { KaiProApiClient } from '@kaiizen/kai-pro-api';
import { useMemo } from 'react';
import { useKaiProApiState } from './contexts';
import { useAuth } from './useAuth';

export const useKaiProApiClient = () => {
  const { token, handleAuthError } = useAuth();
  const { apiUrl } = useKaiProApiState();
  return useMemo(() => new KaiProApiClient({ token, errorHandler: handleAuthError, apiUrl }), [token, handleAuthError, apiUrl]);
};
